import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { LoginCater } from './LoginBody'
import LayoutAuth from './LayoutAuth'
import { LoginContextProvider, Status, useLoginContext, } from './LoginContext';
import { VerifyCodeCater } from './VerifyCode';
import { useLoginController } from './LoginContextController';
import { useResourceRegister } from '~/utils/resourceRegister';
import { CreateAccountLink, ResetPasswordLink } from '~/components/authentication/login/loginComponentAffiliates';


const Login: FC = () => {
  useResourceRegister({ name: 'login-preload' })

  return (
    <LayoutAuth>
      <Helmet>
        <title>Login | OnData</title>
      </Helmet>
      <LoginContextProvider value={useLoginController()}>
        <PhaseSwitcher />
      </LoginContextProvider>
      
    </LayoutAuth>
  );
};

export default Login;

const PhaseSwitcher: FC = () => {
  const { states } = useLoginContext()
  const link1 : any = <CreateAccountLink />
  const link2 : any = <ResetPasswordLink />
  return (
    // <div aria-live="polite">
    //   {
    //   }
    // </div>
      states.status !== Status.Phase2 ?
        <LoginCater CreateAccountLink={link1} ResetPasswordLink={link2} /> :
        <VerifyCodeCater />
  )
}
